import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const MarketIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			className={props.className}
			onClick={props.onClick}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M23 6L13.5 15.5L8.5 10.5L1 18M23 6H17M23 6V12"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default MarketIcon
